module.exports = __webpack_public_path__ + "static/img/title.57c7409.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/feature6/title.png
// module id = NitC
// module chunks = 7